module.exports = __webpack_public_path__ + "img/pic_brazil_03.7cf2fcc8.jpg";